import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import useCartStore from '@/store/cartStore';

export function CartButton({ onClick }) {
  const totalItems = useCartStore((state) => state.getTotalItems());

  return (
    <Button
      onClick={onClick}
      className="fixed bottom-24 right-6 z-40 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all"
      size="icon"
      aria-label={`購物車，${totalItems} 件商品`}
    >
      <div className="relative">
        <ShoppingCart className="h-6 w-6" />
        {totalItems > 0 && (
          <Badge 
            className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center p-0 bg-red-500 text-white text-xs"
          >
            {totalItems > 99 ? '99+' : totalItems}
          </Badge>
        )}
      </div>
    </Button>
  );
}
